export default __webpack_public_path__ + "static/media/CRLonsdaleClosed.bea58d35.jpg";